import * as PIXI from 'pixi.js';
import Asset from './Asset';
import HUEShifter from '../../HUEShifter';

export default class ImageAsset extends Asset {
    constructor(assetManager) {
        super(assetManager);
        this.type = 'IMAGE';

        this.image = null;
        this.preloadImage = '';

        this._hueShifts = [];
    }

    getHue(rotation) {
        const hue = Math.round(rotation / 10) * 10;
        if (!this._hueShifts[hue]) {
            this._hueShifts[hue] = HUEShifter.shift(hue, this);
        }
        return this._hueShifts[hue];
    }

    load(id, url, onLoad, onError) {
        this.id = id;

        const self = this;
        const internalOnLoad = () => {
            self.loaded = true;

            this.image = PIXI.Texture.from(this.imageSource);
            this._hueShifts = [this.image];

            if (onLoad) onLoad(self);
        };
        const internalOnError = error => {
            if (onError)
                onError({
                    msg: error
                });
            else throw error;
        };

        this.imageSource = new Image();
        this.imageSource.onload = internalOnLoad;
        this.imageSource.onerror = internalOnError;
        this.imageSource.src = url;
    }

    get() {
        return this.image;
    }
}
